module.exports = __webpack_public_path__ + "static/media/img_online.36905feb.png";